import React, { useState } from 'react';
import { CalendarIcon, PercentIcon, InfoIcon, FileTextIcon } from 'lucide-react';
export function QuoteDetailsStep({
  initialData,
  onUpdate
}) {
  const [formData, setFormData] = useState({
    quoteTitle: initialData.quoteTitle || '',
    quoteDescription: initialData.quoteDescription || '',
    relatedPivot: initialData.relatedPivot || '',
    pivotSerialNumber: initialData.pivotSerialNumber || '',
    discount: initialData.discount || 0,
    urgency: initialData.urgency || 'normal',
    notes: initialData.notes || '',
    ...initialData
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    onUpdate({
      ...formData,
      [name]: value
    });
  };
  return <div className="space-y-6" data-id="element-5019">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-5 rounded-t-xl shadow-sm" data-id="element-5020">
        <div className="flex items-center" data-id="element-5021">
          <div className="p-2 mr-3 bg-blue-100 dark:bg-blue-900/40 rounded-lg" data-id="element-5022">
            <FileTextIcon size={20} className="text-blue-600 dark:text-blue-400" data-id="element-5023" />
          </div>
          <div data-id="element-5024">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-5025">
              Quote Details
            </h2>
            <p className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-5026">
              Provide the basic information for this quote
            </p>
          </div>
        </div>
      </div>
      {/* Basic Information */}
      <div className="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-5027">
        <div className="flex items-center mb-4" data-id="element-5028">
          <FileTextIcon size={20} className="text-blue-600 dark:text-blue-400 mr-2" data-id="element-5029" />
          <h3 className="text-gray-900 dark:text-white font-medium" data-id="element-5030">
            Basic Information
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-5031">
          <div data-id="element-5032">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5033">
              Quote Title
            </label>
            <input type="text" name="quoteTitle" value={formData.quoteTitle} onChange={handleChange} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="E.g. Replacement Parts for Valley Center Pivot" data-id="element-5034" />
          </div>
          <div data-id="element-5035">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5036">
              Urgency
            </label>
            <select name="urgency" value={formData.urgency} onChange={handleChange} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none" style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%236B7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '20px'
          }} data-id="element-5037">
              <option value="low" data-id="element-5038">Low Priority</option>
              <option value="normal" data-id="element-5039">Normal</option>
              <option value="high" data-id="element-5040">High Priority</option>
              <option value="critical" data-id="element-5041">Critical/Emergency</option>
            </select>
          </div>
        </div>
        <div className="mb-4" data-id="element-5042">
          <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5043">
            Quote Description
          </label>
          <textarea name="quoteDescription" value={formData.quoteDescription} onChange={handleChange} rows={3} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Provide a brief description of what these spare parts are for" data-id="element-5044"></textarea>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5045">
          <div data-id="element-5046">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5047">
              Related Pivot/Machine
            </label>
            <input type="text" name="relatedPivot" value={formData.relatedPivot} onChange={handleChange} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="E.g. Valley 8000 series" data-id="element-5048" />
          </div>
          <div data-id="element-5049">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5050">
              Serial Number (if applicable)
            </label>
            <input type="text" name="pivotSerialNumber" value={formData.pivotSerialNumber} onChange={handleChange} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Enter machine serial number" data-id="element-5051" />
          </div>
        </div>
      </div>
      {/* Discount and Notes */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5052">
        {/* Discount Section */}
        <div className="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-5053">
          <div className="flex items-center mb-4" data-id="element-5054">
            <div className="p-2 mr-2 bg-blue-100 dark:bg-blue-900/40 rounded-lg" data-id="element-5055">
              <PercentIcon size={20} className="text-blue-600 dark:text-blue-400" data-id="element-5056" />
            </div>
            <h3 className="text-gray-900 dark:text-white font-medium" data-id="element-5057">
              Discount
            </h3>
          </div>
          <div data-id="element-5058">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5059">
              Discount Percentage (%)
            </label>
            <div className="flex items-center" data-id="element-5060">
              <input type="range" name="discount" min="0" max="50" step="1" value={formData.discount} onChange={handleChange} className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer accent-blue-500" data-id="element-5061" />
              <span className="ml-3 text-gray-900 dark:text-white font-medium min-w-[3rem] text-right" data-id="element-5062">
                {formData.discount}%
              </span>
            </div>
            <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-5063">
              <span data-id="element-5064">0%</span>
              <span data-id="element-5065">25%</span>
              <span data-id="element-5066">50%</span>
            </div>
          </div>
          <div className="mt-4 bg-gray-50 dark:bg-gray-750 rounded-lg p-4 border border-gray-200 dark:border-gray-700" data-id="element-5067">
            <div className="flex items-start" data-id="element-5068">
              <InfoIcon size={18} className="text-blue-600 dark:text-blue-400 mr-2 mt-0.5" data-id="element-5069" />
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-5070">
                Discounts are applied to the subtotal before shipping and taxes.
                Maximum discount is limited to 50%.
              </p>
            </div>
          </div>
        </div>
        {/* Notes Section */}
        <div className="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-5071">
          <div className="flex items-center mb-4" data-id="element-5072">
            <div className="p-2 mr-2 bg-blue-100 dark:bg-blue-900/40 rounded-lg" data-id="element-5073">
              <CalendarIcon size={20} className="text-blue-600 dark:text-blue-400" data-id="element-5074" />
            </div>
            <h3 className="text-gray-900 dark:text-white font-medium" data-id="element-5075">
              Additional Notes
            </h3>
          </div>
          <div data-id="element-5076">
            <textarea name="notes" value={formData.notes} onChange={handleChange} rows={5} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Enter any additional notes, special requirements or instructions..." data-id="element-5077"></textarea>
          </div>
        </div>
      </div>
    </div>;
}